import i18n from '@/shared/i18n';

export const getSEOCategoryTitle = (label, category, subcategory) => {
  if (subcategory?.seoTitle) {
    return subcategory.seoTitle;
  }

  if (subcategory?.name && i18n.te(`meta.${label}.subcategory.title`)) {
    return i18n.t(`meta.${label}.subcategory.title`, { subcategory: subcategory.name });
  }

  if (i18n.te(`meta.${label}.title`)) {
    return i18n.t(`meta.${label}.title`);
  }

  return i18n.t('meta.default.category.title', { category });
};

export const getSEOCategoryDescription = (label, category, subcategory) => {
  if (subcategory?.seoDescription) {
    return subcategory.seoDescription;
  }

  if (subcategory?.name && i18n.te(`meta.${label}.subcategory.description`)) {
    return i18n.t(`meta.${label}.subcategory.description`, { subcategory: subcategory.name });
  }

  if (i18n.te(`meta.${label}.description`)) {
    return i18n.t(`meta.${label}.description`);
  }

  return i18n.t('meta.default.category.description', { category });
};
